import { ComprobanteDetalle } from '@shared/models/comprobante';
import { Usuario } from './usuario';
import { BaseModel } from './base-model';
import { ServicioClienteInternet } from './servicio-cliente';

export interface Receipt {
  id?: number | null;
  usuarioId?: number | null;
  fechaEmision?: string;
  fechaVencimiento: string;
  mes?: number;
  montoTotal?: number;
  registrador?: number;
  fechaRegistro?: string;
  fechaActualizacion?: string;
  estado?: string;
  usuario?: Usuario;
  reciboClienteItem?: ReciboClienteItem[];
  reciboClientePago?: ReciboClientePago;
}

export class ReciboCliente extends BaseModel {
  usuarioId?: number | null;
  fechaEmision?: string;
  fechaVencimiento?: string;
  mes?: number | null;
  montoTotal?: number | null;
  registrador?: number | null;
  fechaRegistro?: string;
  fechaActualizacion?: string;
  estado?: string | null;
  usuario?: Usuario;
  reciboClienteItem?: ReciboClienteItem[];
  reciboClientePago?: ReciboClientePago;

  constructor(object?: any) {
    super(object);
    if (object) {
      if (object.montoTotal) {
        this.montoTotal = +object.montoTotal;
      }
      if (object.usuario) {
        this.usuario = new Usuario(object.usuario);
      }
      if (object.reciboClientePago) {
        this.reciboClientePago = new ReciboClientePago(object.reciboClientePago);
      }
      if (object.reciboClienteItem) {
        this.reciboClienteItem = object.reciboClienteItem.map((data: any) => new ReciboClienteItem(data));
      }
    }
  }

  initializeValues(): void {
    this.id = null;
    this.usuarioId = null;
    this.fechaEmision = '';
    this.fechaVencimiento = '';
    this.mes = null;
    this.montoTotal = null;
    this.registrador = null;
    this.estado = null;
  }
}

export class ReciboClienteItem extends BaseModel {
  reciboClienteId?: number | null;
  servicioClienteId?: number | null;
  servicioClienteInternetId?: number | null;
  tipoItem?: string;
  descripcion?: string;
  monto?: number | null;
  mes?: number | null;
  fechaRegistro?: string;
  fechaActualizacion?: string;
  estado?: string;
  reciboCliente?: ReciboCliente;
  reciboClientePago?: ReciboClientePago;
  servicioClienteInternet?: ServicioClienteInternet;

  constructor(object?: any) {
    super(object);
    if (object) {
      if (object.monto) {
        this.monto = +object.monto;
      }
      if (object.reciboCliente) {
        this.reciboCliente = new ReciboCliente(object.reciboCliente);
      }
      if (object.reciboClientePago) {
        this.reciboClientePago = new ReciboClientePago(object.reciboClientePago);
      }
      if (object.servicioClienteInternet) {
        this.servicioClienteInternet = new ServicioClienteInternet(object.servicioClienteInternet);
      }
    }
  }

  initializeValues(): void {
    this.id = null;
    this.reciboClienteId = null;
    this.servicioClienteId = null;
    this.servicioClienteInternetId = null;
    this.tipoItem = '';
    this.descripcion = '';
    this.monto = null;
    this.mes = null;
    this.estado = '';
  }
}

export class ReciboClientePago extends BaseModel {
  reciboClienteId?: number | null;
  formaPagoDetalleId?: number | null;
  comprobanteDetalleId?: number | null;
  fechaPago?: string;
  codigoOperacion?: string;
  numeroComprobante?: number | null;
  fechaVencimientoComprobante?: string;
  comision?: number;
  fechaRegistro?: string;
  fechaActualizacion?: string;
  estado?: string;
  reciboCliente?: ReciboCliente;
  comprobanteDetalle?: ComprobanteDetalle;

  constructor(object?: any) {
    super(object);
    if (object) {
      if (object.reciboCliente) {
        this.reciboCliente = new ReciboCliente(object.reciboCliente);
      }
      if (object.comprobanteDetalle) {
        this.comprobanteDetalle = new ComprobanteDetalle(object.comprobanteDetalle);
      }
    } else {
      this.initializeValues();
    }
  }

  initializeValues(): void {
    this.reciboClienteId = null;
    this.formaPagoDetalleId = null;
    this.comprobanteDetalleId = null;
    this.fechaPago = '';
    this.codigoOperacion = '';
    this.numeroComprobante = null;
    this.fechaVencimientoComprobante = '';
    this.comision = 0.0;
    this.estado = '';
  }
}
